module.exports = "data:image/gif;base64,R0lGODlhAQC0AIABAFilxgAAACH5BAEAAAEALAAAAAABALQAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7"


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/BlueOpal/slider-h.gif
// module id = ../../../../../external_css/kendo-ui/BlueOpal/slider-h.gif
// module chunks = styles